import { notifications } from '~/app/notifications'
import PageCheckoutItems from '~/themes/base/components/cart/PageCheckoutItems'

export default {
  mixins: [PageCheckoutItems],
  components: {
    VCalendar: () => import('v-calendar'),
  },
  data() {
    return {
      selectedDate: {
        start: new Date(this.$store.state.cart.renting.startDate),
        end: new Date(this.$store.state.cart.renting.endDate),
        rentDuration: 1,
      },
    }
  },
  watch: {
    selectedDate: function(date) {
      if (this.selectedDate.start && this.selectedDate.end) {
        this.calculateRentDuration()
        this.$store.commit('cart/SET_RENT_DATES', this.selectedDate)
        this.$store.commit('cart/SET_RENT_DURATION', this.selectedDate.rentDuration)
        this.updateBackend()
      }
    },
  },
  computed: {
    groupedCartItems() {
      // Groups the same items in cart into one line
      let cartItems = this.$store.state.cart.cartData.items
      let groupedCartItems = []

      for (let item of cartItems) {
        let group = groupedCartItems.find(group => group.id === item.product.id)
        if (group) {
          group.amount += 1
        } else {
          let newItem = { ...item }
          newItem.id = item.product.id
          newItem.amount = 1
          groupedCartItems.push(newItem)
        }
      }
      return groupedCartItems
    },
  },
  beforeMount() {
    this.calculateRentDuration()
  },
  methods: {
    async updateBackend(value) {
      const items = this.$store.state.cart.cartData.items
      notifications.info('Přepočítávám cenu košíku')
      for (let x = 1; x <= items.length; x++) {
        if (x === items.length) {
          await this.$store.dispatch('cart/UPDATE_ITEM', {
            id: items[x - 1].id,
            quantity: this.selectedDate.rentDuration,
          })
        } else {
          try {
            await this.$axios.$patch(this.$env.STORE_URL + '/api/v1/cart/items/' + items[x - 1].id, {
              amount: Number(this.selectedDate.rentDuration),
            })
          } catch (e) {
            console.log(e)
          }
        }
      }
    },
    calculateRentDuration() {
      let timeDifference = this.selectedDate.end.getTime() - this.selectedDate.start.getTime()
      this.selectedDate.rentDuration = Math.max(1, parseInt(timeDifference / (1000 * 3600 * 24)))
    },
  },
}
